"use client";

import React, { useContext, useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { User as UserIcon } from "lucide-react";
import client from "@/lib/api/client";
import { useLayout } from "@/lib/context/layout";
import { LogoElement } from "./Logo";
import { ContextElement } from "./ContextSelector";
import { RegionSelection } from "./RegionSelection";
import { TasksElement } from "./Tasks";
import { UserDetailsElement } from "./UserDetails";

export const AppTopbar = () => {
    const { layoutState, showProfileSidebar, enableDashboards } = useLayout();
    const [loggedIn, setLoggedIn] = useState(enableDashboards);

    useEffect(() => setLoggedIn(enableDashboards), [enableDashboards]);

    let option_buttons = (
        <Link href="#" onClick={(e) => { e.preventDefault(); client.do_auth(); }}>
            <Button variant="ghost" size="icon" className="h-10 w-10">
                <UserIcon className="h-5 w-5" />
            </Button>
        </Link>
    );

    let style: React.CSSProperties = { display: "none" };
    if (loggedIn) {
        style = {};
        option_buttons = (
            <>
                <TasksElement />
                <UserDetailsElement />
            </>
        );
    }

    return (
        <div
            className="fixed top-0 left-0 w-full z-[997] flex items-center gap-3 px-4 bg-card border-b border-border shadow-[0_1px_2px_rgba(0,0,0,0.04)]"
            style={{ height: "var(--topbar-height)", ...style }}
        >
            <div className="flex items-center pr-4">
                <LogoElement />
            </div>
            <div className="flex items-center gap-3 ml-4">
                <ContextElement />
                <RegionSelection />
            </div>
            <div className="flex items-center gap-2 ml-auto">
                <Button
                    variant="ghost"
                    size="icon"
                    className="h-10 w-10 lg:hidden"
                    onClick={showProfileSidebar}
                >
                    <span className="text-xl">⋯</span>
                </Button>
                {option_buttons}
            </div>
        </div>
    );
};
